import { base64Roboto, base64SF } from './index'

export const setDocIcon = (icon: string) => {
  document.head.querySelector('link[rel="icon"]')?.setAttribute('href', icon)
  document.head.querySelector('link[rel="apple-touch-icon"]')?.setAttribute('href', icon)
}

export const setDocTitle = (title: string) => (document.title = title)

export const setDocBackgroundColor = (color: string) =>
  document.documentElement.style.setProperty('--background', color)

export const setDocFont = (fontFamily: string) => {
  const style = document.getElementById('font')
  if (style) {
    style.innerHTML = fontFamily === 'Roboto' ? base64Roboto : base64SF
  }
}
